import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Configuration } from '../configuration';
import { BASE_PATH } from '../variables';
import { ApiError } from '../error';
import { VyVGetAssureursAdressesResponse } from '../models/VyVESHGetAssureursAdresses';
import { AppConfig } from 'src/app/app.config';

@Injectable()
export class RefAssureurService {
  protected basePath = '/';
  public defaultHeaders = new HttpHeaders({
    'x-brand': this.appConfig.getConfig('brand')
  });
  public configuration = new Configuration();

  constructor(
    @Inject(AppConfig) private appConfig: AppConfig,
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }
  public getAssureurs(
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<VyVGetAssureursAdressesResponse>;
  public getAssureurs(
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<VyVGetAssureursAdressesResponse>>;
  public getAssureurs(
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<VyVGetAssureursAdressesResponse>>;
  public getAssureurs(observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    const path = `${this.basePath}/api/assureurs`;
    let headers = this.defaultHeaders;
    return this.httpClient.request<VyVGetAssureursAdressesResponse>('get', path, {
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  private handleApiError(path: string, error: HttpErrorResponse) {
    let message: string;
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      message = 'A client side error occurred: ' + error.error;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      message = 'A server side error occurred: ' + error.status;
    }

    return throwError(() => new ApiError(message, path, error));
  }
}
